import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var PaymentLogoIdeal = _ref => {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoIdeal',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M0 3.359v15.615c0 .748.647 1.36 1.437 1.36h9.868c7.46 0 10.695-3.949 10.695-9.188C22 5.934 18.766 2 11.306 2H1.437C.647 2 0 2.612 0 3.359Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#C06",
    d: "M6.605 5.832v11.539h5.311c4.823 0 6.914-2.576 6.914-6.218 0-3.486-2.091-6.19-6.914-6.19H7.525c-.51 0-.92.394-.92.87Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    d: "M11.306 19.09H2.723c-.762 0-1.38-.585-1.38-1.305V4.555c0-.72.618-1.305 1.38-1.305h8.582c8.143 0 9.357 4.954 9.357 7.903 0 5.117-3.328 7.937-9.357 7.937ZM2.723 3.685c-.51 0-.92.388-.92.87v13.23c0 .483.41.87.92.87h8.582c5.735 0 8.897-2.664 8.897-7.502 0-6.496-5.577-7.468-8.897-7.468H2.723Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M8.474 9.597c.187 0 .36.027.524.082.166.054.302.142.424.25a1.4 1.4 0 0 1 .28.422c.065.17.101.367.101.598 0 .204-.028.387-.079.557-.057.17-.136.32-.244.442a1.184 1.184 0 0 1-.41.292c-.165.068-.36.109-.582.109H7.23V9.59h1.244v.007Zm-.043 2.25a.95.95 0 0 0 .273-.042.539.539 0 0 0 .23-.142.785.785 0 0 0 .165-.258c.043-.11.065-.231.065-.388 0-.136-.015-.265-.043-.374a.727.727 0 0 0-.144-.285.646.646 0 0 0-.259-.183 1.113 1.113 0 0 0-.395-.062h-.46v1.74h.568v-.007Zm3.967-2.25v.51H10.86v.59h1.416v.47H10.86v.672h1.574v.51H10.22V9.59h2.178v.007Zm2.199 0 1.093 2.759h-.669l-.223-.612h-1.092l-.23.612h-.647l1.1-2.759h.668Zm.036 1.692-.366-1.012h-.008l-.38 1.012h.754Zm2.099-1.692v2.25h1.423v.509h-2.063V9.597h.64Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    d: "M4.205 12.247c.742 0 1.344-.569 1.344-1.27 0-.702-.602-1.271-1.344-1.271-.743 0-1.345.569-1.345 1.27 0 .702.602 1.271 1.345 1.271Zm1.013 5.123c-1.128 0-2.034-.862-2.034-1.922v-1.502c0-.53.453-.965 1.02-.965.561 0 1.021.428 1.021.965v3.425h-.007Z"
  }));
};
PaymentLogoIdeal.displayName = 'PaymentLogoIdeal';
export default withProvisionalOverrideFromContext(PaymentLogoIdeal);
//# sourceMappingURL=index.js.map